export interface SubscribeToDogBreedButtonControllerData {
  subscriptionEmail: string | null;
  breedName?: string;
  iconOnlyMobile?: boolean;
  openTooltipOnClick?: boolean; // When openTooltipOnClick is not specified, we default to opening it on mobile
  onFallbackClick?(): void;
  hasADog?: boolean | null;
}

export interface SubscribeToDogBreedButtonControllerProps
  extends SubscribeToDogBreedButtonControllerData {}
